<template>
  <div id="app">
    <CuToastSheet
      :show="toastSheet.show"
      :type="toastSheet.type"
      :title="toastSheet.title"
      :description="toastSheet.description"
      @close="dismissToastSheet"
    />
    <router-view />
  </div>
</template>

<script>
import { ref, provide, onMounted, onUnmounted } from 'vue'
import appClient from './api/appClient'
import CuToastSheet from './components/dialog-sheets/CuToastSheet.vue'
import eventBus from './utils/eventBus'

export default {
  name: 'App',
  components: { CuToastSheet },
  setup() {
    const user = ref(null)
    const loadingUser = ref(true)
    const toastSheet = ref({
      show: false,
      type: 'success',
      title: '',
      description: ''
    })

    provide('user', user)
    provide('loadingUser', loadingUser)

    function showToast({ message, type = 'success', title = '', duration = 3000 }) {
      toastSheet.value = {
        show: true,
        type,
        title: title || (type === 'success' ? 'Successo' : 'Errore'),
        description: message
      }
      // Optionally auto-dismiss after duration
      if (duration > 0) {
        setTimeout(() => {
          toastSheet.value.show = false
        }, duration)
      }
    }

    function dismissToastSheet() {
      toastSheet.value.show = false
    }


    async function getProfile() {
      const token = localStorage.getItem('castingup_app_token')
      if (token) {
        try {
          const res = await appClient.post('/profile', {})
          if (res.data && res.data.status && res.data.data && res.data.data.id) {
            user.value = res.data.data
            console.log('User profile loaded:', user.value)
          } else {
            user.value = null
            localStorage.removeItem('castingup_app_token')
          }
        } catch (e) {
          user.value = null
          localStorage.removeItem('castingup_app_token')
        }
      }
      loadingUser.value = false
    }

    // Expose globally
    if (typeof window !== 'undefined') {
      window.$toast = showToast
    }

    // Listen for user refresh events
    const handleUserRefresh = () => {
      console.log('User refresh event received')
      eventBus.emit('refreshProfileAndMedia');
      getProfile()
    }

    onMounted(async () => {
      await getProfile()
      // Subscribe to user refresh events
      eventBus.on('userRefresh', handleUserRefresh)
    })

    onUnmounted(() => {
      // Clean up event listener
      eventBus.off('userRefresh', handleUserRefresh)
    })

    return { toastSheet, dismissToastSheet }
  }
}
</script>

<style>
#app {
  @apply font-sans text-center text-gray-800 mt-0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow-y: auto;
}
button.bg-black, .card.bg-black {
  background-color:#282B2E;
}

html, body {
  height: 100%;
  overscroll-behavior: contain;
  overflow-y: hidden;
}

</style>
